export default "__VITE_ASSET__CxRQmmhB__"